// src/mobile/MobileReserveRide.js
import React from "react";

const MobileReserveRide = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Reserve Your Ride</h2>
      <p>You can reserve your taxi quickly and easily here.</p>
    </div>
  );
};

export default MobileReserveRide;
